import { StatsPanel } from '.';

export default class Stats {
  public dom: HTMLElement;

  public update: () => void;

  private begin: () => void;

  private end: () => number;

  constructor(parent: HTMLElement, style: { [key: string]: string } = null) {
    let mode: number = 0;
    const container: HTMLDivElement = document.createElement('div');
    if (!style) {
      container.style.position = 'absolute';
      container.style.top = '0px';
      container.style.left = '0px';
      container.style.opacity = '.8';
      container.style.zIndex = '1000';
    } else {
      for (const key in style) {
        if (style.hasOwnProperty(key)) {
          const val = style[key];
          container.style[key] = val;
        }
      }
    }

    function showPanel(id: number): void {
      for (let i = 0; i < container.children.length; i += 1) {
        const el: any = container.children[i];
        el.style.display = i === id ? 'block' : 'none';
      }
      mode = id;
    }

    parent.appendChild(container);
    container.addEventListener('click', (e: MouseEvent & TouchEvent): void => {
      e.preventDefault();
      mode += 1;
      showPanel(mode % container.children.length);
    }, false);

    function addPanel(panel: StatsPanel): StatsPanel {
      container.appendChild(panel.dom);
      return panel;
    }

    let beginTime: number = (performance || Date).now(); let prevTime = beginTime; let
      frames = 0;
    const fpsPanel: StatsPanel = addPanel(new StatsPanel('FPS', '#0ff', '#002'));
    const msPanel: StatsPanel = addPanel(new StatsPanel('MS', '#0f0', '#020'));
    showPanel(0);

    /**
     * public
    */
    this.dom = container;
    this.begin = (): void => {
      beginTime = (performance || Date).now();
    };

    this.end = (): number => {
      frames += 1;
      const time: number = (performance || Date).now();
      msPanel.update(time - beginTime, 200);

      if (time >= prevTime + 1000) {
        fpsPanel.update((frames * 1000) / (time - prevTime), 100);
        prevTime = time;
        frames = 0;
      }
      return time;
    };

    this.update = (): void => {
      beginTime = this.end();
    };
  }
}
